import FJTextarea from '../../../common/components/FJTextarea/FJTextarea';
import styles from './FJPromptInput.module.less';
import ReUploadIcon from '../../../assets/svg/re-upload.svg?react';
import UploadIcon from '../../../assets/svg/upload.svg?react';
import AddFileWhiteIcon from '../../../assets/svg/add-file-white.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useRef } from 'react';
import FJPreviewBox from '../../../common/components/FJPreviewBox/FJPreviewBox';

const FJPromptInput = props => {
    const {
        prompt,
        uploadImageInfo = {},
        changePrompt,
        uploadImg,
        isDraggingFile,
        setIsDraggingFile,
        openMediaLibrary,
    } = props;
    const { src: imgSrc } = uploadImageInfo;
    const inputRef = useRef(null);
    const _onchangePrompt = e => {
        changePrompt(e.target.value);
    };
    const _onUploadImg = e => {
        const file = e.target.files[0];
        uploadImg(file);
        e.target.value = null;
    };

    const _onClick = () => {
        if (window.isEditPage && openMediaLibrary) {
            openMediaLibrary();
        } else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = e.dataTransfer.files;
        if (files && files.length > 0) {
            const file = files[0];
            uploadImg(file);
        }
    };
    return (
        <div className={styles.box}>
            <div
                className={classNames(styles.img_preview_box, imgSrc ? styles.has_img : '')}
                onClick={_onClick}
                onDragOver={_onDragOver}
                onDrop={_onDragDrop}
                onDragLeave={_onDragLeave}
            >
                {imgSrc ? (
                    <>
                        <img className={styles.preview_img} src={imgSrc} alt='' loading='lazy' />
                        <div className={classNames(styles.input_mask, isDraggingFile ? styles.dragging : '')}>
                            {isDraggingFile ? <AddFileWhiteIcon /> : <ReUploadIcon />}
                            <span className={styles.reupload_text}>
                                {isDraggingFile ? FJLocalStore._('upload-image') : FJLocalStore._('change-image')}
                            </span>
                        </div>
                        <FJPreviewBox imageInfo={uploadImageInfo} />
                    </>
                ) : (
                    <div
                        className={classNames(styles.upload_file_box, {
                            [styles.upload_file_box_dragging]: isDraggingFile,
                        })}
                    >
                        <UploadIcon />
                        <span className={styles.blank_text}>{FJLocalStore._('upload-image')}</span>

                        <div className={classNames(styles.none_input_mask, isDraggingFile ? styles.dragging : '')}>
                            {isDraggingFile ? <AddFileWhiteIcon /> : <ReUploadIcon />}
                            <span className={styles.reupload_text}>
                                {isDraggingFile ? FJLocalStore._('upload-image') : FJLocalStore._('change-image')}
                            </span>
                        </div>
                    </div>
                )}

                <input
                    type='file'
                    ref={inputRef}
                    className={styles.file_input}
                    accept={UPLOAD_FILE_TYPE_NO_GIF}
                    onChange={_onUploadImg}
                />
                <div className={styles.dragging_mask}></div>
            </div>
            <FJTextarea
                className={styles.textarea}
                text={prompt}
                placeholder={FJLocalStore._('describe-the-image-briefly-to-get-more-accurate-results')}
                onChange={_onchangePrompt}
                maxLength={200}
            />
        </div>
    );
};
FJPromptInput.propTypes = {
    prompt: PropTypes.string,
    uploadImageInfo: PropTypes.object,
    changePrompt: PropTypes.func,
    openMediaLibrary: PropTypes.func,
    imgSrc: PropTypes.string,
    uploadImg: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
};

export default FJPromptInput;
